var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V496H496V336H16Z",
    fill: "#2ECC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 176V336H496V176H16Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V176H496V16H16Z",
    fill: "#3498DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.75 189.25C196.882 189.25 167 219.132 167 256C167 292.868 196.882 322.75 233.75 322.75C256.752 322.75 277.027 311.111 289.031 293.406C278.855 304.602 264.165 311.625 247.844 311.625C217.121 311.625 192.219 286.723 192.219 256C192.219 225.277 217.121 200.375 247.844 200.375C264.165 200.375 278.855 207.398 289.031 218.594C277.027 200.889 256.752 189.25 233.75 189.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M334.163 282.206L315.029 273.127L307.947 293.086L300.836 273.137L281.715 282.242L290.794 263.108L270.834 256.026L290.784 248.916L281.678 229.795L300.812 238.874L307.895 218.914L315.005 238.864L334.126 229.758L325.047 248.892L345.007 255.974L325.057 263.084L334.163 282.206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/AZ.0c0a18acb3dbd5bed22375683a626c6e.svg";
export { ForwardRef as ReactComponent };